<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item label="新人礼开关" prop="isOpen">
          <a-switch :checked="form.isOpen === 1" checked-children="开启" un-checked-children="关闭" @change="onSwitchChange" />
          <span style="margin-left: 12px; color: #999;">开启后，新用户注册即发放以下奖励</span>
        </a-form-model-item>
        <a-form-model-item label="赠送现金余额" prop="cashAmount">
          <a-input-number v-model="form.cashAmount" :min="0" :precision="2" :step="1" style="width: 200px" placeholder="0.00" />
          <span style="margin-left: 8px;">元</span>
        </a-form-model-item>
        <a-form-model-item label="赠送积分" prop="scoreAmount">
          <a-input-number v-model="form.scoreAmount" :min="0" :precision="0" :step="1" style="width: 200px" placeholder="0" />
          <span style="margin-left: 8px;">积分</span>
        </a-form-model-item>
        <a-form-model-item label="赠送优惠券" prop="couponIdList">
          <a-select
            v-model="form.couponIdList"
            mode="multiple"
            style="width: 100%"
            placeholder="请选择要赠送的优惠券（可多选）"
            :filter-option="filterOption"
            allow-clear
          >
            <a-select-option v-for="item in couponList" :key="item.id" :value="item.id">
              {{ item.couponName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea v-model="form.remark" :maxLength="255" :rows="3" placeholder="请输入备注" allow-clear />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 4 }">
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保 存</a-button>
          <a-button style="margin-left: 12px;" @click="getConfig">重 置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getNewGiftConfig, saveNewGiftConfig } from '@/api/user/newGiftConfig'
import { listCoupon } from '@/api/activity/coupon'

export default {
  name: 'NewGiftConfig',
  data () {
    return {
      submitLoading: false,
      couponList: [],
      form: {
        id: undefined,
        isOpen: 0,
        cashAmount: 0,
        scoreAmount: 0,
        couponIdList: [],
        remark: undefined
      },
      rules: {}
    }
  },
  created () {
    this.getCouponList()
    this.getConfig()
  },
  methods: {
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    onSwitchChange (checked) {
      this.form.isOpen = checked ? 1 : 0
    },
    getCouponList () {
      listCoupon({ pageNum: 1, pageSize: 200 }).then(response => {
        this.couponList = response.data || response.rows || []
      })
    },
    getConfig () {
      getNewGiftConfig().then(response => {
        const data = response.data || {}
        this.form = {
          id: data.id,
          isOpen: data.isOpen || 0,
          cashAmount: data.cashAmount || 0,
          scoreAmount: data.scoreAmount || 0,
          couponIdList: data.couponIdList || [],
          remark: data.remark
        }
      })
    },
    submitForm () {
      this.$refs['form'].validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        saveNewGiftConfig(this.form).then(() => {
          this.$message.success('保存成功')
          this.getConfig()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
